/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* utilities */
import { parseDataToProps } from '~/utilities';

const modelFilterNodes = Array.from(document.querySelectorAll('.model-filter'));
if (modelFilterNodes.length) {
    import(/* webpackChunkName: "ModelFilter" */ './components/ModelFilter').then(({ default: ModelFilter }) => {
        modelFilterNodes.forEach((node) => render(<ModelFilter {...parseDataToProps(node.dataset)}/>, node));
    });
}
